export const DOCUMENT_PROCESSING_STATUS = [
   { value: "Needs review", label: "Needs review" },
   { value: "Extracted", label: "Extracted" },
   { value: "Extracting", label: "Extracting" },
   { value: "Uploaded", label: "Uploaded" },
   { value: "Uploading", label: "Uploading" },
   { value: "Completed", label: "Completed" },
   { value: "Failed", label: "Failed" },
   { value: "Pending", label: "Pending" },
];
